module.exports = __webpack_public_path__ + "static/media/pinkMarriage.6009446a.jpg";